import { render } from "./AdminMobileNav.vue?vue&type=template&id=1cdb2048"
import script from "./AdminMobileNav.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdminMobileNav.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script